(ns ductile.ui.load-builder-v2.move-menu
  (:require [clojure.string :as str]
            [ductile.ui.components.popover :as popover]
            [ductile.ui.load-builder-v2.selectors :as lb2sel]
            [ductile.ui.locale :refer [tr]]))

(defn waypoint-label [{:address/keys [postcode city]}]
  (str (or postcode "?") " " (or city (tr "Unknown"))))

(defn- transport-card-menu
  [{:keys [menu draft-ids on-close on-edit-transport on-save-draft on-dismiss-draft
           on-print-load-list on-focus-transport-map on-hide-transport-map]}]
  (let [{:keys [x y transport-id focused? collapsed? show-print-load-list? show-edit-route?
                on-toggle-collapsed on-edit-route]} menu
        draft? (contains? draft-ids transport-id)]
    [popover/anchored-popover
     {:x x
      :y y
      :on-close on-close
      :data-testid "transport-context-menu"
      :est-width 280
      :est-height 220
      :class "rounded-lg border border-slate-200 bg-white shadow-[0_12px_28px_rgba(15,23,42,0.18)] overflow-hidden text-[12px]"
      :style {:min-width 220
              :max-width 280}}
     [:div.flex.flex-col
      (when-not draft?
        [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
         {:data-popover-item "true"
          :role "menuitem"
          :data-testid "transport-context-edit"
          :on-click #(do (on-edit-transport transport-id) (on-close))}
         (tr "Edit")])
      [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
       {:data-popover-item "true"
        :role "menuitem"
        :data-testid (if collapsed?
                       "transport-context-expand"
                       "transport-context-collapse")
        :on-click #(do (when on-toggle-collapsed
                         (on-toggle-collapsed transport-id))
                       (on-close))}
       (if collapsed?
         (tr "Expand")
         (tr "Collapse"))]
      (when draft?
        [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
         {:data-popover-item "true"
          :role "menuitem"
          :data-testid "transport-context-save-draft"
          :on-click #(do (on-save-draft transport-id) (on-close))}
         (tr "Save")])
      (when show-edit-route?
        [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
         {:data-popover-item "true"
          :role "menuitem"
          :data-testid "transport-context-edit-route"
          :on-click #(do (when on-edit-route
                           (on-edit-route))
                         (on-close))}
         (tr "Edit route")])
      (when show-print-load-list?
        [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
         {:data-popover-item "true"
          :role "menuitem"
          :data-testid "transport-context-print-load-list"
          :on-click #(do (on-print-load-list transport-id) (on-close))}
         (tr "Print load list")])
      [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
       {:data-popover-item "true"
        :role "menuitem"
        :data-testid (if focused?
                       "transport-context-hide-map"
                       "transport-context-show-map")
        :on-click #(do ((if focused? on-hide-transport-map on-focus-transport-map) transport-id)
                       (on-close))}
       (if focused?
         (tr "Hide from map")
         (tr "Show on map"))]
      (when draft?
        [:<>
         [:div.border-t.border-slate-200.my-1]
         [:button.w-full.text-left.px-3.py-1.hover:bg-red-50.focus:bg-red-50.outline-none.text-red-700
          {:data-popover-item "true"
           :role "menuitem"
           :data-testid "transport-context-discard-draft"
           :on-click #(do (on-dismiss-draft transport-id) (on-close))}
          (tr "Discard")]])]]))

(defn- move-target-buttons
  [{:keys [ordered-transport-ids source-transport-id transport-summaries draft-ids
           draft-index-by-id on-move vehicle-ids on-close]}]
  (for [target-id ordered-transport-ids
        :when (not= target-id source-transport-id)
        :let [{:keys [vehicle-id-set vehicle-count load-id carrier-label waypoints]}
              (get transport-summaries target-id {})
              target-current-ids (or vehicle-id-set #{})
              target-count (or vehicle-count 0)
              moved-in-count (count (remove target-current-ids vehicle-ids))
              disabled? (> (+ target-count moved-in-count) 7)
              draft? (contains? draft-ids target-id)
              draft-index (get draft-index-by-id target-id)]]
    ^{:key (str "target-" target-id)}
    [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none.disabled:opacity-40.border-b.last:border-b-0.border-slate-100
     {:data-popover-item "true"
      :role "menuitem"
      :data-testid (str "move-target-" target-id)
      :disabled disabled?
      :on-click #(do (on-move source-transport-id target-id vehicle-ids)
                     (on-close))}
     [:div.flex.items-center.gap-2.min-w-0
      [:span.text-slate-500 (str target-count "/7")]
      (if draft?
        [:<>
         [:span.inline-flex.rounded.bg-amber-100.text-amber-800.px-1.py-0.font-bold
          {:class "text-[11px]"}
          (tr "Draft")]
         [:span.font-medium (str (tr "Draft transport") " " draft-index)]]
        [:span.font-medium (or load-id (tr "No load ID"))])]
     (when (seq carrier-label)
       [:span.text-slate-500.truncate.ml-1 carrier-label])
     (when (seq waypoints)
       [:div.text-slate-500.truncate {:class "mt-0.5"}
        (str/join " → " (map waypoint-label waypoints))])]))

(defn view [{:keys [menu transport-ids draft-ids transport-summaries
                    draft-order
                    context-filter-action
                    show-fahrzeuge-on-transports?
                    on-focus-selection-map
                    on-select-vehicles
                    on-copy-vins
                    on-open-vehicle-details
                    on-edit-transport
                    on-save-draft
                    on-dismiss-draft
                    on-print-load-list
                    on-focus-transport-map
                    on-hide-transport-map
                    on-toggle-show-fahrzeuge-on-transports
                    on-close on-move on-move-to-staging on-create-with-vehicle on-remove-from-staging
                    on-remove-from-load
                    on-add-filter
                    show-extra-actions?]
             :or {show-extra-actions? true}}]
  (let [{:keys [x y vehicle-id vehicle-ids source-transport-id from kind]} menu
        vehicle-ids (vec (or vehicle-ids [vehicle-id]))
        vehicle-count (count vehicle-ids)
        single-vehicle? (= 1 vehicle-count)
        map-pin? (= kind :map-pin)
        copy-vins-label (if single-vehicle?
                          (tr "Copy VIN")
                          (tr "Copy VINs"))
        show-on-map-label (if map-pin?
                            (if single-vehicle?
                              (tr "Show vehicle on map")
                              (tr "Show %1 vehicles on map" vehicle-count))
                            (tr "Show selection on map"))
        select-vehicles-label (if single-vehicle?
                                (tr "Select vehicle")
                                (tr "Select %1 vehicles" vehicle-count))
        move-to-staging-label (if map-pin?
                                (if single-vehicle?
                                  (tr "Move vehicle to staging")
                                  (tr "Move %1 vehicles to staging" vehicle-count))
                                (tr "Move to staging"))
        remove-from-load-label (if map-pin?
                                 (if single-vehicle?
                                   (tr "Remove from load")
                                   (tr "Remove %1 vehicles from load" vehicle-count))
                                 (tr "Remove from load"))
        create-draft-label (if map-pin?
                             (if single-vehicle?
                               (tr "Create new draft transport for vehicle")
                               (tr "Create new draft transport for %1 vehicles" vehicle-count))
                             (tr "Create new draft transport with selection"))
        ordered-draft-ids (lb2sel/ordered-draft-ids draft-ids draft-order)
        ordered-transport-ids (lb2sel/ordered-transport-ids transport-ids ordered-draft-ids)
        draft-index-by-id (lb2sel/draft-index-by-id ordered-draft-ids)
        max-width 400]
    (cond
      (= kind :transport-card)
      [transport-card-menu {:menu menu
                            :draft-ids draft-ids
                            :on-close on-close
                            :on-edit-transport on-edit-transport
                            :on-save-draft on-save-draft
                            :on-dismiss-draft on-dismiss-draft
                            :on-print-load-list on-print-load-list
                            :on-focus-transport-map on-focus-transport-map
                            :on-hide-transport-map on-hide-transport-map}]
      :else
      [popover/anchored-popover
       {:x x
        :y y
        :on-close on-close
        :data-testid "move-menu"
        :est-width max-width
        :est-height 420
        :class "rounded-lg border border-slate-200 bg-white shadow-[0_12px_28px_rgba(15,23,42,0.18)] overflow-hidden text-[12px]"
        :style {:min-width 260
                :max-width max-width}}
       (when show-extra-actions?
         [:div.border-b.border-slate-200
          (when (and (= :map from) on-toggle-show-fahrzeuge-on-transports)
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "toggle-show-vehicles-on-transports"
              :on-click #(do (on-toggle-show-fahrzeuge-on-transports)
                             (on-close))}
             (tr (if show-fahrzeuge-on-transports?
                   "Hide vehicles on transports"
                   "Show vehicles on transports"))])
          (when (and context-filter-action on-add-filter)
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "add-cell-filter"
              :on-click #(do (on-add-filter context-filter-action) (on-close))}
             (:label context-filter-action)])
          (when (and on-focus-selection-map
                     (not= kind :map-empty)
                     (seq vehicle-ids))
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "show-selection-on-map"
              :on-click #(do (on-focus-selection-map vehicle-ids) (on-close))}
             show-on-map-label])
          (when (and on-select-vehicles
                     (= kind :map-pin)
                     (seq vehicle-ids))
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "select-vehicles"
              :on-click #(do (on-select-vehicles vehicle-ids) (on-close))}
             select-vehicles-label])
          (when (and on-copy-vins
                     (not= kind :map-empty)
                     (seq vehicle-ids))
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "copy-vins"
              :on-click #(do (on-copy-vins vehicle-ids) (on-close))}
             copy-vins-label])
          (when (and on-open-vehicle-details
                     (not= kind :map-empty)
                     single-vehicle?)
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "open-vehicle-details"
              :on-click #(do (on-open-vehicle-details (first vehicle-ids)) (on-close))}
             (tr "Show vehicle details in new tab")])
          (when (and (not= kind :map-empty) (not= :staging from))
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "move-to-staging"
              :on-click #(do (on-move-to-staging source-transport-id vehicle-ids) (on-close))}
             move-to-staging-label])
          (when (not= kind :map-empty)
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "create-draft-with-selection"
              :on-click #(do (on-create-with-vehicle source-transport-id vehicle-ids) (on-close))}
             create-draft-label])
          (when (and (not= kind :map-empty) (= :staging from))
            [:button.w-full.text-left.px-3.py-1.hover:bg-slate-50.focus:bg-slate-50.outline-none
             {:data-popover-item "true"
              :role "menuitem"
              :data-testid "remove-from-staging"
              :on-click #(do (on-remove-from-staging vehicle-ids) (on-close))}
             (tr "Remove from staging")])])
       (when (and (not= kind :map-empty)
                  (= :transport from)
                  on-remove-from-load)
         [:div.border-b.border-slate-200
          [:button.w-full.text-left.px-3.py-1.hover:bg-red-50.focus:bg-red-50.outline-none.text-red-700
           {:data-popover-item "true"
            :role "menuitem"
            :data-testid "remove-from-load"
            :on-click #(do (on-remove-from-load source-transport-id vehicle-ids) (on-close))}
           remove-from-load-label]])
       (when (not= kind :map-empty)
         [:div.max-h-80.overflow-auto
          (into [:<>]
                (move-target-buttons {:ordered-transport-ids ordered-transport-ids
                                      :source-transport-id source-transport-id
                                      :transport-summaries transport-summaries
                                      :draft-ids draft-ids
                                      :draft-index-by-id draft-index-by-id
                                      :on-move on-move
                                      :vehicle-ids vehicle-ids
                                      :on-close on-close}))])])))
